import React from 'react';
import classnames from 'classnames';

var styles = {"ProgressBar":"S1cioqW7loo-","SteppedProgressBar":"nv5fejwjHzo-","wrapper":"dyBDsjWCui4-"};

var sizes = {"smaller":"CzIxUWYkrdo-","small":"JNSDqHqKVlE-","base":"nzFMJ2k4zJ0-"};

function ProgressBarStepped({ currentStep, totalSteps, percentage, size = "base", }) {
    const steppedProgressBarClassName = classnames(styles.ProgressBar, styles.SteppedProgressBar, sizes[size]);
    const ariaLabel = `progress, ${currentStep} out of ${totalSteps}`;
    return (React.createElement("div", { role: "progressbar", className: styles.wrapper, "aria-valuenow": percentage, "aria-valuetext": ariaLabel }, Array.from({ length: totalSteps }).map((_, index) => {
        const step = index + 1;
        const value = step <= currentStep ? 100 : 0;
        return (React.createElement("progress", { key: step, className: steppedProgressBarClassName, value: value, "data-testid": "progress-step" },
            value,
            "%"));
    })));
}

function ProgressBar({ currentStep, totalSteps, size = "base", variation = "progress", }) {
    const percentage = (currentStep / totalSteps) * 100;
    const progressBarClassName = classnames(styles.ProgressBar, sizes[size]);
    if (variation === "stepped") {
        return (React.createElement(ProgressBarStepped, { currentStep: currentStep, totalSteps: totalSteps, percentage: percentage, size: size }));
    }
    return (React.createElement("progress", { className: progressBarClassName, max: totalSteps, value: currentStep },
        percentage,
        "%"));
}

export { ProgressBar as P };
